
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3361',
  depVersions: {
  "customer-portal-app": "static-1.3361",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.510",
  "data-fetching-client": "static-1.10095",
  "emoji-mart": "static-3.6",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26463",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6048",
  "hs-test-utils": "static-1.8493",
  "hub-http": "static-1.6665",
  "hub-http-shared-msw-handlers": "static-1.10865",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19245",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11947",
  "I18n": "static-7.1704",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6908",
  "payment-link-components": "static-1.24403",
  "portals-platform-bend-plugin": "static-1.26",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7635",
  "quartz-core": "static-1.6854",
  "quartz-i18n": "static-1.1310",
  "react": "static-7.202",
  "react-colorpicker": "static-2.10667",
  "react-dlb": "static-1.93",
  "react-utils": "static-2.5647",
  "reselect": "static-3.16",
  "rich-text-lib": "static-1.20520",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18538",
  "ui-components-test-utils": "static-1.6084",
  "UIComponents": "static-3.8893",
  "foundations-assets": "static-1.5342",
  "foundations-components": "static-1.8712",
  "foundations-theming": "static-1.4943",
  "foundations-theming-specialty": "static-1.2659",
  "framer-motion": "static-1.83",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1687",
  "quartz-config": "static-1.1413",
  "quartz-routing": "static-1.1065",
  "quick-fetch": "static-1.4222",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17191",
  "rpc-client-utils": "static-1.5128",
  "sanitize-text": "static-1.8613",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.65",
  "ui-addon-draggable": "static-3.5204",
  "ui-addon-react-router-dom": "static-1.9984",
  "usage-tracker": "static-1.7777",
  "usage-tracker-anonymous": "static-1.6194",
  "usage-tracker-core": "static-1.7627",
  "video-components-external": "static-1.12394",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3912",
  "quartz-webpack": "static-1.3859",
  "bend-plugin-quartz-routing": "static-1.713",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.93",
  "customer-data-objects": "static-1.8152",
  "frontend-preferences-client": "static-1.8375",
  "laboratory-lib": "static-3.7605",
  "onboarding-scopes": "static-1.6908",
  "seat-types-lib": "static-1.1009",
  "ui-addon-opt": "static-4.8846",
  "HeadJS": "static-2.817",
  "hs-test-utils-bend-plugin": "static-1.3604",
  "msw": "static-1.102",
  "msw-config": "static-1.26",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.391",
  "ts-schema": "static-1.4385",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8392",
  "content-media-capture": "static-1.5749",
  "cssUtils": "static-1.1078",
  "customer-data-ui-utilities": "static-1.10289",
  "file-manager-components": "static-1.24800",
  "HubStyle": "static-2.12254",
  "knowledge-content-types": "static-1.8743",
  "PatternValidationJS": "static-1.3342",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.517",
  "ui-addon-emoji-picker": "static-1.10320",
  "ui-addon-i18n": "static-1.11601",
  "ui-business-units-lib": "static-1.9553",
  "ui-shepherd-react": "static-3.10733",
  "video-data-lib": "static-1.36052",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4764",
  "commerce-tours-lib": "static-1.6829",
  "customer-data-properties": "static-1.52986",
  "getting-started-shared-tasks": "static-1.19524",
  "growth-onboarding-reliability": "static-1.5537",
  "onboarding-tours": "static-1.17367",
  "reference-resolvers-lite": "static-1.8563",
  "sales-checkout-service-client": "static-1.3980",
  "ui-addon-iframeable": "static-1.9531",
  "user-context": "static-1.5509",
  "bender-build-tools": "static-1.3553",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.904",
  "hubspotter-http": "static-1.4966",
  "icons": "static-2.700",
  "mobile-manifest-mixins": "static-1.602",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1-unrevert-default-instrumentation.4",
  "quartz-auth": "static-1.1310",
  "quartz-head": "static-1.1300",
  "quartz-test": "static-1.1310",
  "quartz-tracking": "static-1.1014",
  "trellis-components": "static-1.3058",
  "ui-fonts": "static-1.1209",
  "usage-tracker-container": "static-1.7767",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9879",
  "data-token-picker": "static-1.17099",
  "FileManagerLib": "static-1.40440",
  "property-translator": "static-1.5835",
  "merchandise-lib": "static-1.283",
  "purchase-motions-components": "static-1.6605",
  "SharedI18nStrings": "static-1.187",
  "foundations-components-test-utils": "static-1.6195",
  "react-create-root-preference": "static-1.99",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "ui-images": "static-2.1274",
  "bend-plugin-foundations-components": "static-1.4981",
  "floating-ui": "static-1.67",
  "react-aria": "static-1.76",
  "trellis-assets": "static-1.3039",
  "bend-plugin-foundations-theming": "static-1.3426",
  "foundations-theming-base": "static-1.3928",
  "stylex": "static-1.46",
  "interframe": "static-3.5198",
  "js-cookie": "static-1.18",
  "pdf-js": "static-2.49",
  "usage-tracker-multi": "static-1.6191",
  "opentelemetry-fe-types": "static-1-unrevert-default-instrumentation.4",
  "beacon-keepalive-queue": "static-1.155",
  "web-vitals": "static-1.19",
  "bend-plugin-chirp-manifest": "static-1.538",
  "chirp-fetch": "static-1.2359",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4930",
  "react-flip-move": "static-1.82",
  "apollo-link-hub-http": "static-2.5043",
  "content-media-composition-data-lib": "static-1.13553",
  "content-media-compositions": "static-2.17560",
  "idb-keyval": "static-1.55",
  "immer": "static-1.105",
  "immerable": "static-1.4598",
  "magpie-lib": "static-1.5894",
  "magpie-types": "static-1.5354",
  "media-bridge-lib": "static-1.19609",
  "opentelemetry-web": "static-1.22",
  "inbound-db-properties-service-client": "static-1.4142",
  "superstore": "static-1.5214",
  "feedback-loader": "static-1.30027",
  "ai-components-ui-library": "static-1.9980",
  "ui-addon-video-player": "static-1.9080",
  "ui-coaching-tips": "static-1.29561",
  "ContentUtils": "static-1.69427",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4882",
  "sassPrefix": "static-1.344",
  "react-dnd-compat": "static-1.5067",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.2088",
  "copilot-toolkit": "static-1.12107",
  "poll-commands": "static-1.3931",
  "atom": "static-1.5531",
  "avatar-components": "static-1.2942",
  "navigation-messaging": "static-1.8448",
  "redux-thunk": "static-2.84",
  "reference-resolvers": "static-1.8636",
  "commerce-products-lib": "static-1.10852",
  "crm-message-bus": "static-1.44053",
  "growth-data-modal": "static-1.6104",
  "hubspot-apollo-client": "static-1.5335",
  "onboarding-tours-client": "static-1.5582",
  "batch-promise": "static-1.2002",
  "calling-global-api": "static-1.66126",
  "calling-internal-common": "static-1.31781",
  "calling-lifecycle-internal": "static-1.67508",
  "calling-lifecycle-messages": "static-1.59801",
  "conditional-properties-service-client": "static-1.4104",
  "crm-index-visualization-core": "static-1.4730",
  "crm-links": "static-1.6762",
  "crm-pipelines-api-client-types": "static-1.4435",
  "customer-data-objects-ui-components": "static-1.13486",
  "customer-data-properties-shared-msw-handlers": "static-1.10192",
  "customer-data-property-utils": "static-1.8503",
  "external-options-client-types": "static-1.4431",
  "formula-editor": "static-1.14982",
  "framework-data-schema-resolvers": "static-1.7350",
  "google-libphonenumber": "static-1.49",
  "hs-resources": "static-1.648",
  "inbound-db-meta-service-client": "static-1.3768",
  "inbounddb-objects-service-types": "static-1.4514",
  "meetings-icalendar-utils-lib": "static-1.1093",
  "multi-currency-client-types": "static-1.3999",
  "object-builder-ui-client": "static-1.49997",
  "pipeline-validation-client-types": "static-1.4272",
  "property-value-citations": "static-1.3600",
  "pulse": "static-1.1099",
  "smart-data-capture-core": "static-1.436",
  "smart-property-lib": "static-1.8594",
  "tiered-pricing": "static-1.2198",
  "topics-actions-lib": "static-1.634",
  "trellis-ext-i18n": "static-1.1353",
  "trial-components-library": "static-1.14343",
  "ui-addon-form-validation": "static-1.11343",
  "zustand": "static-1.88",
  "growth-onboarding-confetti": "static-1.3517",
  "growth-onboarding-next-action-utils": "static-1.2946",
  "navigation-components": "static-1.19121",
  "onboarding-tours-utils": "static-1.1434",
  "ui-shepherd-tracker": "static-1.8114",
  "ui-universal-auth": "static-1.9684",
  "getting-started-shared-tasks-store": "static-1.18642",
  "hubspotter-http-shared-msw-handlers": "static-1.10863",
  "usage-tracker-session-replay": "static-1.5463",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1449",
  "tanstack-virtual": "static-1.42",
  "audio-components": "static-1.6538",
  "FileManagerCore": "static-1.40299",
  "FileManagerImages": "static-1.37951",
  "video-components": "static-1.14396",
  "foundations-components-legacy": "static-1.1737",
  "purchase-motions-api": "static-1.6608",
  "signup-constants": "static-1.19902",
  "signup-ui-url-generator": "static-2.8513",
  "stylex-utils": "static-1.170",
  "usage-tracker-public": "static-1.7588",
  "reactive-lib": "static-1.1179",
  "simple-logging-lib": "static-1.3508",
  "nudge-client-utils": "static-1.3383",
  "chatspot-core": "static-1.23737",
  "growth-onboarding-feedback-components": "static-1.7038",
  "cms-field-types": "static-1.5268",
  "content-icons-ui": "static-1.2439",
  "integrations-lib": "static-1.17383",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.1066",
  "breeze-engine-core": "static-1.1366",
  "ably": "static-2.2",
  "highlight.js": "static-1.90",
  "markdown-it": "static-1.6",
  "trellis-migration-context": "static-1.34",
  "nav-meta": "static-1.30758",
  "commerce-permissions": "static-1.1241",
  "customer-data-tracking": "static-1.7328",
  "products-iframe-lib": "static-1.8864",
  "products-ui-components-shared-msw-handlers": "static-1.11247",
  "restore-request-side-panel-lib": "static-1.1981",
  "onboarding-data-sync-lib": "static-1.2807",
  "hubspot-apollo-cache": "static-1.794",
  "calling-error-reporting": "static-1.31788",
  "shared-worker-versioning": "static-1.11497",
  "calling-usage-tracker": "static-1.6990",
  "voice-sms-access-library": "static-1.2394",
  "conversations-skeleton-state": "static-1.7605",
  "crm-index-associations-lib": "static-1.6905",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10948",
  "redux-toolkit": "static-1.82",
  "sales-views-client-types": "static-1.4712",
  "location-customization-utils-lib": "static-1.10378",
  "bark-lib": "static-1.16988",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6346",
  "react-codemirror": "static-1.11096",
  "fdsr-migration-layer": "static-1.469",
  "framework-builder-read-service-client": "static-1.4324",
  "framework-data-schema-quick-fetch": "static-1.7255",
  "persist-promise": "static-1.4159",
  "event-emitter": "static-1.1417",
  "bend-plugin-pulse": "static-1.602",
  "fast-json-patch": "static-1.74",
  "data-agent-kit": "static-1.876",
  "data-agent-test-utils": "static-1.420",
  "data-agent-utils": "static-1.889",
  "fsm": "static-1.4214",
  "policy-lib": "static-1.7264",
  "react-tinymce": "static-1.56231",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11011",
  "tinymce-config": "static-2.55357",
  "tinymce-plugins": "static-1.58471",
  "embedded-academy-lib": "static-1.15956",
  "hubs-service-types": "static-1.1721",
  "salesImages": "static-1.711",
  "growth-onboarding-next-action-components": "static-1.2974",
  "user-context-client": "static-1.4965",
  "nest": "static-1.689",
  "unified-auth-core-lib": "static-1.1480",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.852",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4971",
  "video-embed": "static-1.36886",
  "social-insights-client-types": "static-1.22893",
  "nudge-custom-function-registry": "static-1.3140",
  "nudge-renderer-utils": "static-1.3459",
  "whisper-core-api": "static-1.7600",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14798",
  "integrations-tracking-lib": "static-1.6072",
  "native-integrations-shared-strings": "static-1.8219",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10825",
  "rxjs": "static-5.10",
  "InboxConnectUtils": "static-4.15808",
  "meetings-connect-utils-lib": "static-1.8072",
  "calling-orchestration-schema": "static-1.37171",
  "crm-record-cards-service-types": "static-1.3864",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16631",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.115",
  "trellis-story-utils": "static-1.4956",
  "enrichment-settings-lib": "static-1.204",
  "storybook-react": "static-1.44",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57327",
  "hub-http-contrib": "static-1.3486",
  "tinymce-data": "static-1.41442",
  "ui-addon-sales-email": "static-1.5658",
  "layout-dnd-components": "static-1.13190",
  "layout-dnd-utils": "static-1.12165",
  "ui-brand-identity-lib": "static-1.16901",
  "academy-common-lib": "static-1.15417",
  "outpost": "static-1.4588",
  "universal-page-editor-lib": "static-1.3465",
  "NamespacedHubStyle": "static-2.9359",
  "ContentData": "static-1.69502",
  "layout-data-lib": "static-1.10490",
  "academy-service-client": "static-1.4147",
  "croppie": "static-2.10",
  "final-form": "static-1.82",
  "SafeStorage": "static-1.4851",
  "trellis-ecosystem": "static-1.7816",
  "wootric-nps": "static-1.7288",
  "advanced-menus-core": "static-1.15779",
  "advanced-menus-lib": "static-1.12541",
  "ExportDialog": "static-6.10827",
  "ui-memberships-settings-lib": "static-1.35138",
  "marketplace-ui-apps-core": "static-1.19544",
  "marketplace-ui-common": "static-1.21012",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15778",
  "simple-menus-lib": "static-1.17295",
  "settings-ui-lib": "static-1.12986",
  "developer-experience-shared-components": "static-1.10994",
  "immutable-less": "static-1.5108",
  "marketplace-ui-client-types": "static-1.18419",
  "ui-addon-integrations-directory-panel": "static-2.8410",
  "ui-extensibility-client-types": "static-1.4372",
  "ai-settings-ui-library": "static-1.8550",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1530",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4597",
  "simple-data-table": "static-1.3790"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3361",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.510",
  "data-fetching-client": "/data-fetching-client/static-1.10095",
  "emoji-mart": "/emoji-mart/static-3.6",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26463",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6048",
  "hs-test-utils": "/hs-test-utils/static-1.8493",
  "hub-http": "/hub-http/static-1.6665",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10865",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19245",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11947",
  "I18n": "/I18n/static-7.1704",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6908",
  "payment-link-components": "/payment-link-components/static-1.24403",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.26",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7635",
  "quartz-core": "/quartz-core/static-1.6854",
  "quartz-i18n": "/quartz-i18n/static-1.1310",
  "react": "/react/static-7.202",
  "react-colorpicker": "/react-colorpicker/static-2.10667",
  "react-dlb": "/react-dlb/static-1.93",
  "react-utils": "/react-utils/static-2.5647",
  "reselect": "/reselect/static-3.16",
  "rich-text-lib": "/rich-text-lib/static-1.20520",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18538",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6084",
  "UIComponents": "/UIComponents/static-3.8893",
  "foundations-assets": "/foundations-assets/static-1.5342",
  "foundations-components": "/foundations-components/static-1.8712",
  "foundations-theming": "/foundations-theming/static-1.4943",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2659",
  "framer-motion": "/framer-motion/static-1.83",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1687",
  "quartz-config": "/quartz-config/static-1.1413",
  "quartz-routing": "/quartz-routing/static-1.1065",
  "quick-fetch": "/quick-fetch/static-1.4222",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17191",
  "rpc-client-utils": "/rpc-client-utils/static-1.5128",
  "sanitize-text": "/sanitize-text/static-1.8613",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.65",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5204",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9984",
  "usage-tracker": "/usage-tracker/static-1.7777",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6194",
  "usage-tracker-core": "/usage-tracker-core/static-1.7627",
  "video-components-external": "/video-components-external/static-1.12394",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3912",
  "quartz-webpack": "/quartz-webpack/static-1.3859",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.713",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.93",
  "customer-data-objects": "/customer-data-objects/static-1.8152",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8375",
  "laboratory-lib": "/laboratory-lib/static-3.7605",
  "onboarding-scopes": "/onboarding-scopes/static-1.6908",
  "seat-types-lib": "/seat-types-lib/static-1.1009",
  "ui-addon-opt": "/ui-addon-opt/static-4.8846",
  "HeadJS": "/HeadJS/static-2.817",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3604",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.26",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.391",
  "ts-schema": "/ts-schema/static-1.4385",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8392",
  "content-media-capture": "/content-media-capture/static-1.5749",
  "cssUtils": "/cssUtils/static-1.1078",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10289",
  "file-manager-components": "/file-manager-components/static-1.24800",
  "HubStyle": "/HubStyle/static-2.12254",
  "knowledge-content-types": "/knowledge-content-types/static-1.8743",
  "PatternValidationJS": "/PatternValidationJS/static-1.3342",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.517",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10320",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11601",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9553",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10733",
  "video-data-lib": "/video-data-lib/static-1.36052",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4764",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6829",
  "customer-data-properties": "/customer-data-properties/static-1.52986",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19524",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5537",
  "onboarding-tours": "/onboarding-tours/static-1.17367",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8563",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3980",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9531",
  "user-context": "/user-context/static-1.5509",
  "bender-build-tools": "/bender-build-tools/static-1.3553",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.904",
  "hubspotter-http": "/hubspotter-http/static-1.4966",
  "icons": "/icons/static-2.700",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.602",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-unrevert-default-instrumentation.4",
  "quartz-auth": "/quartz-auth/static-1.1310",
  "quartz-head": "/quartz-head/static-1.1300",
  "quartz-test": "/quartz-test/static-1.1310",
  "quartz-tracking": "/quartz-tracking/static-1.1014",
  "trellis-components": "/trellis-components/static-1.3058",
  "ui-fonts": "/ui-fonts/static-1.1209",
  "usage-tracker-container": "/usage-tracker-container/static-1.7767",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9879",
  "data-token-picker": "/data-token-picker/static-1.17099",
  "FileManagerLib": "/FileManagerLib/static-1.40440",
  "property-translator": "/property-translator/static-1.5835",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "purchase-motions-components": "/purchase-motions-components/static-1.6605",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6195",
  "react-create-root-preference": "/react-create-root-preference/static-1.99",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "ui-images": "/ui-images/static-2.1274",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4981",
  "floating-ui": "/floating-ui/static-1.67",
  "react-aria": "/react-aria/static-1.76",
  "trellis-assets": "/trellis-assets/static-1.3039",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3426",
  "foundations-theming-base": "/foundations-theming-base/static-1.3928",
  "stylex": "/stylex/static-1.46",
  "interframe": "/interframe/static-3.5198",
  "js-cookie": "/js-cookie/static-1.18",
  "pdf-js": "/pdf-js/static-2.49",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6191",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-unrevert-default-instrumentation.4",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.155",
  "web-vitals": "/web-vitals/static-1.19",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.538",
  "chirp-fetch": "/chirp-fetch/static-1.2359",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4930",
  "react-flip-move": "/react-flip-move/static-1.82",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5043",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13553",
  "content-media-compositions": "/content-media-compositions/static-2.17560",
  "idb-keyval": "/idb-keyval/static-1.55",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4598",
  "magpie-lib": "/magpie-lib/static-1.5894",
  "magpie-types": "/magpie-types/static-1.5354",
  "media-bridge-lib": "/media-bridge-lib/static-1.19609",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4142",
  "superstore": "/superstore/static-1.5214",
  "feedback-loader": "/feedback-loader/static-1.30027",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9980",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9080",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29561",
  "ContentUtils": "/ContentUtils/static-1.69427",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4882",
  "sassPrefix": "/sassPrefix/static-1.344",
  "react-dnd-compat": "/react-dnd-compat/static-1.5067",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2088",
  "copilot-toolkit": "/copilot-toolkit/static-1.12107",
  "poll-commands": "/poll-commands/static-1.3931",
  "atom": "/atom/static-1.5531",
  "avatar-components": "/avatar-components/static-1.2942",
  "navigation-messaging": "/navigation-messaging/static-1.8448",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reference-resolvers": "/reference-resolvers/static-1.8636",
  "commerce-products-lib": "/commerce-products-lib/static-1.10852",
  "crm-message-bus": "/crm-message-bus/static-1.44053",
  "growth-data-modal": "/growth-data-modal/static-1.6104",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5335",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5582",
  "batch-promise": "/batch-promise/static-1.2002",
  "calling-global-api": "/calling-global-api/static-1.66126",
  "calling-internal-common": "/calling-internal-common/static-1.31781",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67508",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59801",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4104",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4730",
  "crm-links": "/crm-links/static-1.6762",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4435",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13486",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10192",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8503",
  "external-options-client-types": "/external-options-client-types/static-1.4431",
  "formula-editor": "/formula-editor/static-1.14982",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7350",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "hs-resources": "/hs-resources/static-1.648",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3768",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4514",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1093",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3999",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49997",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4272",
  "property-value-citations": "/property-value-citations/static-1.3600",
  "pulse": "/pulse/static-1.1099",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.436",
  "smart-property-lib": "/smart-property-lib/static-1.8594",
  "tiered-pricing": "/tiered-pricing/static-1.2198",
  "topics-actions-lib": "/topics-actions-lib/static-1.634",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1353",
  "trial-components-library": "/trial-components-library/static-1.14343",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11343",
  "zustand": "/zustand/static-1.88",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3517",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2946",
  "navigation-components": "/navigation-components/static-1.19121",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1434",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8114",
  "ui-universal-auth": "/ui-universal-auth/static-1.9684",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18642",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10863",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5463",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1449",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "audio-components": "/audio-components/static-1.6538",
  "FileManagerCore": "/FileManagerCore/static-1.40299",
  "FileManagerImages": "/FileManagerImages/static-1.37951",
  "video-components": "/video-components/static-1.14396",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1737",
  "purchase-motions-api": "/purchase-motions-api/static-1.6608",
  "signup-constants": "/signup-constants/static-1.19902",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8513",
  "stylex-utils": "/stylex-utils/static-1.170",
  "usage-tracker-public": "/usage-tracker-public/static-1.7588",
  "reactive-lib": "/reactive-lib/static-1.1179",
  "simple-logging-lib": "/simple-logging-lib/static-1.3508",
  "nudge-client-utils": "/nudge-client-utils/static-1.3383",
  "chatspot-core": "/chatspot-core/static-1.23737",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7038",
  "cms-field-types": "/cms-field-types/static-1.5268",
  "content-icons-ui": "/content-icons-ui/static-1.2439",
  "integrations-lib": "/integrations-lib/static-1.17383",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1066",
  "breeze-engine-core": "/breeze-engine-core/static-1.1366",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.90",
  "markdown-it": "/markdown-it/static-1.6",
  "trellis-migration-context": "/trellis-migration-context/static-1.34",
  "nav-meta": "/nav-meta/static-1.30758",
  "commerce-permissions": "/commerce-permissions/static-1.1241",
  "customer-data-tracking": "/customer-data-tracking/static-1.7328",
  "products-iframe-lib": "/products-iframe-lib/static-1.8864",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11247",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1981",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2807",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.794",
  "calling-error-reporting": "/calling-error-reporting/static-1.31788",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11497",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6990",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2394",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7605",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6905",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10948",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "sales-views-client-types": "/sales-views-client-types/static-1.4712",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10378",
  "bark-lib": "/bark-lib/static-1.16988",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6346",
  "react-codemirror": "/react-codemirror/static-1.11096",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.469",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4324",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7255",
  "persist-promise": "/persist-promise/static-1.4159",
  "event-emitter": "/event-emitter/static-1.1417",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.602",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "data-agent-kit": "/data-agent-kit/static-1.876",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.420",
  "data-agent-utils": "/data-agent-utils/static-1.889",
  "fsm": "/fsm/static-1.4214",
  "policy-lib": "/policy-lib/static-1.7264",
  "react-tinymce": "/react-tinymce/static-1.56231",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11011",
  "tinymce-config": "/tinymce-config/static-2.55357",
  "tinymce-plugins": "/tinymce-plugins/static-1.58471",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15956",
  "hubs-service-types": "/hubs-service-types/static-1.1721",
  "salesImages": "/salesImages/static-1.711",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2974",
  "user-context-client": "/user-context-client/static-1.4965",
  "nest": "/nest/static-1.689",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1480",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.852",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4971",
  "video-embed": "/video-embed/static-1.36886",
  "social-insights-client-types": "/social-insights-client-types/static-1.22893",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3140",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3459",
  "whisper-core-api": "/whisper-core-api/static-1.7600",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14798",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6072",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8219",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10825",
  "rxjs": "/rxjs/static-5.10",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15808",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8072",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37171",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3864",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16631",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.115",
  "trellis-story-utils": "/trellis-story-utils/static-1.4956",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.204",
  "storybook-react": "/storybook-react/static-1.44",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57327",
  "hub-http-contrib": "/hub-http-contrib/static-1.3486",
  "tinymce-data": "/tinymce-data/static-1.41442",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5658",
  "layout-dnd-components": "/layout-dnd-components/static-1.13190",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12165",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16901",
  "academy-common-lib": "/academy-common-lib/static-1.15417",
  "outpost": "/outpost/static-1.4588",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3465",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9359",
  "ContentData": "/ContentData/static-1.69502",
  "layout-data-lib": "/layout-data-lib/static-1.10490",
  "academy-service-client": "/academy-service-client/static-1.4147",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.82",
  "SafeStorage": "/SafeStorage/static-1.4851",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7816",
  "wootric-nps": "/wootric-nps/static-1.7288",
  "advanced-menus-core": "/advanced-menus-core/static-1.15779",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12541",
  "ExportDialog": "/ExportDialog/static-6.10827",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35138",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19544",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21012",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15778",
  "simple-menus-lib": "/simple-menus-lib/static-1.17295",
  "settings-ui-lib": "/settings-ui-lib/static-1.12986",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10994",
  "immutable-less": "/immutable-less/static-1.5108",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18419",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8410",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4372",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8550",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1530",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "simple-data-table": "/simple-data-table/static-1.3790"
}
};
